import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Col,
  Grid,
  Row,
  StandardUniselection
} from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'

import { RendererProps } from 'site/Renderer'
import { StyledView } from './EditTools.styles'
import Iframe from 'shared/components/Iframe'

const SitemodelView = (objectState: RendererProps) => {
  const { t } = useTranslation()

  const location = useLocation()
  const { pathname, search, hash } = location

  const cleanPathname = useMemo(
    () =>
      pathname.endsWith('/edit')
        ? pathname.slice(0, -'/edit'.length)
        : pathname,
    [pathname]
  )

  const cleanUrl = useMemo(
    () => `${window.location.origin}${cleanPathname}${search}${hash}`,
    [cleanPathname, search, hash]
  )

  const [viewType, setViewType] = useState({
    id: 'desktop',
    value: 'Desktop'
  })

  const iframeRef = useRef<HTMLIFrameElement>(null)

  const sendToIframe = useCallback(() => {
    const contentWindow = iframeRef.current?.contentWindow
    if (contentWindow && objectState) {
      contentWindow.postMessage(
        { type: 'SITEMODEL_CONTENT', payload: objectState },
        '*'
      )
    }
  }, [objectState])

  useEffect(() => {
    const iframeEl = iframeRef.current
    if (!iframeEl) return

    iframeEl.addEventListener('load', sendToIframe)
    return () => iframeEl.removeEventListener('load', sendToIframe)
  }, [sendToIframe])

  return (
    <StyledView>
      <Grid style={{ padding: '0 1rem 1rem 0' }}>
        <Row>
          <Col lg={2}>
            <StandardUniselection
              heightClass='semiSmall'
              selectedOption={viewType}
              options={[
                { id: 'desktop', value: 'Desktop' },
                { id: 'mobile', value: 'Mobile' }
              ]}
              onSelect={(option) => {
                if (option && typeof option === 'object' && 'id' in option) {
                  setViewType(option)
                }
              }}
              label={t('edit-tools.change-view')}
            />
          </Col>
        </Row>
      </Grid>
      <Iframe
        ref={iframeRef}
        src={cleanUrl}
        title='Sitemodel Preview'
        height={viewType.id === 'desktop' ? '800px' : '600px'}
        allow='clipboard-write; camera; microphone; geolocation; midi; payment; usb'
        style={{
          width: `${viewType.id === 'desktop' ? '100%' : '375px'}`,
          border: '1px solid #dcdcdc'
        }}
      />
    </StyledView>
  )
}

export default SitemodelView
